﻿<script>
	import { registerPageComplete } from "../../tealium";
    import model from "../../stores/modelStore";
	import textStore from "../../stores/textStore";
    import { projectSettings, acceptedFileUploadList } from "../../config";
    import { isValid } from "../../validation";

    import PageSection from "../../components/PageSection.svelte";
    import Form from "../../components/Form.svelte";
    import FormRow from "../../components/FormRow.svelte";
    import FormColumn from "../../components/FormColumn.svelte";
    import YesNoGroup from "../../components/YesNoGroup.svelte";
    import TextInput from "../../components/TextInput.svelte";
    import TextArea from "../../components/TextArea.svelte";
    import RadioGroup from "../../components/RadioGroup.svelte";
    import RadioGroupWithImage from "../../components/RadioGroupWithImage.svelte";
    import MonthYearSelect from "../../components/MonthYearSelect.svelte";
    import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
    import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
    import NavigationButtons from "../../components/NavigationButtons.svelte";
    import Deceased from "../../components/Deceased.svelte";
    import FileUpload from "../../components/FileUpload.svelte";
    import EmploymentPlaces from "../../components/EmploymentPlaces.svelte";
    import Select from "../../components/Select.svelte";

    export let pageName = null;
    export let pageTitle = null;
    export let lastVisitedPage = null;
	export let persistUrl = null;
    export let disabled = null;
    export let required = null;
    
    const filePrefix = "PHOTOID";
    const confirmDeceasedIdPrefix = "SPCHILDID";
    let other1FilePrefix = "";
    let other2FilePrefix = "";
    let other1Selected = null;
    let other2Selected = null;

	let buttons;

    const defaultFileUploadOtherOptions = [
        { label: "Bank account statement", value: "BANKSTATEMENT" },
        { label: "Birth Certificate", value: "BIRTHCERT" },
        { label: "Electricity Bill", value: "ELEC" },
        { label: "Marriage Certificate", value: "MARRIAGECERT" },
        { label: "Medicare Card", value: "MEDICARE" },
        { label: "Tenancy Agreement", value: "TENANCY" },
        { label: "Other", value: "OTHER" },
    ];

    let fileUploadOther1Options = [...defaultFileUploadOtherOptions];
    let fileUploadOther2Options = [...defaultFileUploadOtherOptions];


    if (!disabled) {
        $model.lastPageVisited = lastVisitedPage;
        document.title = pageTitle;
    }

    const handleSubmit = async () => {
		buttons.blockNext();
        
        // clean up
        cleanSelections();

		let errors = isValid();

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(response);
			} else {
				registerPageComplete(
					pageName,
					$model.contact.emailAddress,
					$model.contact.phoneNumber,
				);
				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};

	const cleanSelections = () => {
	};

    const fileUploadOther1Change = (e) => {
        other1FilePrefix = e.target.value;

        let index = defaultFileUploadOtherOptions.findIndex(option => option.value === other1FilePrefix);

        let newOptions = [...defaultFileUploadOtherOptions];
        newOptions.splice(index, 1);
        fileUploadOther2Options = [...newOptions];
    }

    const fileUploadOther2Change = (e) => {
        other2FilePrefix = e.target.value;

        let index = defaultFileUploadOtherOptions.findIndex(option => option.value === other2FilePrefix);
        let newOptions = [...defaultFileUploadOtherOptions];
        newOptions.splice(index, 1);
        fileUploadOther1Options = [...newOptions];
    }


    //$:{
    //    console.log("Claimants Id", $model);
    //}
</script>


<PageSection>
	<Form id="form-claimantsIds-details" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Claimant's ID</h1>
			</FormColumn>
		</FormRow>
        	

		<div class="confirmation-box-shadow">
            <FormRow>
                <FormColumn>
                    <YesNoGroup
                        {disabled}
					    {required}
					    name="photoId"
					    label="Do you have current photo ID? For example, a copy of their Drivers Licence, Proof of Age Card (18+ card), or Passport."
                        bind:value={$model.claimDetail.havePhotoIds}
                    />
                </FormColumn>
                <p>Note: if you are a Spouse or Child Claimant, you must provide current photo ID.</p>
            </FormRow>

            {#if $model.claimDetail.havePhotoIds === "Yes"}
                    <FileUpload
                        {disabled}
                        registrationToken={$model.registrationToken}
                        filenamePrefix="{filePrefix}"
                        bind:documentList={$model.claimantIdentityPhotoList}
                        htmlLabel="Please upload copies of these documents."
                    >
                    </FileUpload>
            {/if}

                {#if $model.claimDetail && ($model.claimDetail.havePhotoIds === "No" && $model.claimDetail.claimType==="My own claim")}
                <FormRow>
                    <FormColumn>
                        <YesNoGroup
                            {disabled}
					        {required}
					        name="otherFormId"
					        label="For Living Claimants only, can you provide two forms of other ID? For example, copies of a Birth Certificate, Marriage Certificate, Medicare Card, bank account statement, electricity bill, or Tenancy Agreement."
					        bind:value={$model.claimDetail.haveOtherIds}
                        />
                    </FormColumn>
                </FormRow>
                {/if}
                
                {#if $model.claimDetail && 
                    ($model.claimDetail.claimType==="Spouse claim" || $model.claimDetail.claimType==="Child claim")
                }
                    <FileUpload
                        {disabled}
                        registrationToken={$model.registrationToken}
                        filenamePrefix="{confirmDeceasedIdPrefix}"
                        bind:documentList={$model.deceasedIdDocumentList}
                        htmlLabel="<strong>Please also attach copies any documents you have confirming the identity or date of birth of the deceased person.</strong>"
                    >
                    </FileUpload>
                {/if}

                {#if $model.claimDetail.haveOtherIds === "Yes"}
                    <FormRow>
                        <FormColumn>
                            {#if (!disabled)}
                                <p>
                                    Please upload a copy of the forms of other ID.
                                </p>
                                
                            {/if}
                        </FormColumn>
                    </FormRow>
                    <FormRow>
                        <FormColumn>
                            <Select
                                required
						        {disabled}
						        label="Type"
                                sublabel="Please select an ID or document type for each upload."
						        id="fileupload-other1"
						        bind:value={$model.otherIdDoc1Type}
						        optionList={fileUploadOther1Options}
						        on:change={fileUploadOther1Change}>
                            </Select>
                        </FormColumn>
                        <FormColumn>
                            <FileUpload
                                {disabled}
                                registrationToken={$model.registrationToken}
                                filenamePrefix="{other1FilePrefix}"
                                bind:documentList={$model.claimantIdDocumentList}>
                            </FileUpload>
                        </FormColumn>
                    </FormRow>

                {/if}
		</div>

        <FormRow class="confirmation-hide">
			<FormColumn>
				<NavigationButtons bind:buttons
					nextPageLabel={$model.confirmationPage ? "Confirmation" : "Next"} />
			</FormColumn>
		</FormRow>
	</Form>
</PageSection>

<style>
    h1 {
        margin-bottom: 20px;
    }
</style>